import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EntityType } from 'src/app/enums/enums';
import { IPaginatorEvent } from 'src/app/modules/common/table/table.component';
import { DateTransformService } from 'src/app/services/date-transform.service';
import { DocumentService } from 'src/app/services/document.service';
import { DocumentFormComponent } from '../document-form/document-form.component';

@Component({
  selector: 'app-client-documents-list',
  templateUrl: './client-documents-list.component.html',
  styleUrls: ['./client-documents-list.component.scss'],
})
export class ClientDocumentsListComponent {
  columns = ['Nombre', 'Empleado', 'Tipo', 'Vencimiento', 'Creado por', 'Modificado por'];
  columnsNames = ['name', 'clientName', 'documentType', 'expiration', 'createdBy', 'updatedBy'];

  docsList: any[];

  searchText: string;
  showLoading: boolean = false;

  usersList: any = [];
  total: number = 0;
  offset: number = 0;
  limit: number = 25;

  constructor(
    private documentService: DocumentService,
    public dialog: MatDialog,
    private dateTransformService: DateTransformService
  ) { }

  ngOnInit() {
    this.getDocs();
  }

  search(query: string) {
    this.offset = 0;
    this.searchText = query;
    this.showLoading = true;
    this.getDocs();
  }

  handlePageChange(event: IPaginatorEvent) {
    this.offset = event.offset;
    this.limit = event.limit;
    this.getDocs();
  }

  getDocs() {
    const params = {
      offset: this.offset,
      limit: this.limit,
      entityType: EntityType.CLIENT,
      ...(this.searchText && { search: this.searchText }),
    };
    this.documentService.findAll(1, params).subscribe((res:any) => {
      this.showLoading = false;
      this.docsList = this.dateTransformService.transformDates(res.data);
      this.total = res.total;
    });
  }

  openModal() {
    this.dialog.open(DocumentFormComponent, {
      width: '30%',
      minWidth: '300px',
      data: { isClient: true },
      autoFocus: false,
    }).afterClosed().subscribe(() => {
      this.getDocs();
    });
  }

  update(event:number) {
    this.documentService.findOne(event)
      .subscribe((res) => {
        this.dialog.open(DocumentFormComponent, {
          width: '30%',
          minWidth: '300px',
          data: { isClient: true, document: res },
          autoFocus: false,
        }).afterClosed().subscribe(() => {
          this.getDocs();
        });
      });
  }

  delete(event:any) {
    this.documentService.delete(event)
      .subscribe(() => {
        this.getDocs();
      });
  }
}
